import { gsap } from './gsap';

const buttonReveal = () => {
  const buttons = gsap.utils.toArray('.cta-btn:not(.contact-form .cta-btn), .arrow-btn, .arrow-link:not(.footer .arrow-link)');

  if (buttons.length > 0) {
    buttons.forEach((btn) => {
      gsap.set(btn, { x: -100, autoAlpha: 0 });
      gsap.to(btn, {
        autoAlpha: 1,
        x: 0,
        scrollTrigger: {
          trigger: btn,
          start: 'top bottom',
          toggleActions: 'play none none reverse'
        }
      });
    });
  }
};

export default buttonReveal;
